module.exports = __webpack_public_path__ + "media/images/front/columns_test_img_05-402194e4be5a20d6aef420b6f531915f.jpg";